import firebase from "firebase/app";
import "firebase/database";
import "firebase/firestore";
import "firebase/auth";
import "firebase/functions";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCfvs_82q7OL_Ufw67ZZYgJToL3i3LXRLk",
  authDomain: "el-senoron.firebaseapp.com",
  databaseURL: "https://el-senoron.firebaseio.com",
  projectId: "el-senoron",
  storageBucket: "el-senoron.appspot.com",
  messagingSenderId: "364105948172",
  appId: "1:364105948172:web:62e920da805e114f736229",
  measurementId: "G-K0X31JVEQZ",
};

firebase.initializeApp(firebaseConfig);
firebase.firestore();

export default firebase;
